import { Component, OnInit, EventEmitter, Input, Output, Injector } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'apply-report',
  templateUrl: './apply-report.component.html',
  styleUrls: ['./apply-report.component.scss']
})

export class ApplyReportComponent implements OnInit {
  @Input() show = false;
  @Output()
  apply: EventEmitter<any> = new EventEmitter();

  @Output()
  close: EventEmitter<any> = new EventEmitter();
  change: EventEmitter<any> = new EventEmitter();
  date:Date;
  max: Date = new Date();

  constructor(
    private readonly formBuilder: FormBuilder
  ) {}

  ngOnInit() {
  }

  /**
   * Handles the action when apply button is clicked
  */
  onApply() {
    this.apply.emit(this.date);
    this.show = false;
    this.onClose();
  }


  onChange(date:any) {
    this.change.emit(date);
    this.date = date;
  }
  
  onClose() {
    this.close.emit();
    this.show = false;
  }
}
